// This file is compiled inside Decidim core pack. Code can be added here and will be executed
// as part of that pack

import "src/decidim/append_after_action_to_modals"
import "src/decidim/disable_pwa_prompt.js"

// Load images
require.context("../../images", true)
